export default __webpack_public_path__ + "static/media/280.d212b399.gif";